<template>
    <div v-if="loggedUser" :class="containerClass" @click="onWrapperClick">
        <AppTopBar :class="tolbarClass" @menu-toggle="onMenuToggle" />

        <transition name="layout-sidebar">
            <div :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
                <AppProfile />
                <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
            </div>
        </transition>

        <div class="layout-main" :class="theme">
            <div class="p-grid">
                <LoadingPage v-if="loadingPage" key="loading-page" />
                <LoadingModal v-if="loadingModal" key="loading-modal"/>
                <router-view v-show="!loadingPage"/>
            </div>
        </div>

    </div>
</template>

<script>
    import store from "@/store";
    import EventBus from "@/commons/EventBus";
    import AppTopBar from "@/AppTopbar";
    import AppProfile from "@/AppProfile";
    import AppMenu from "@/AppMenu";
    import LoadingPage from "@/components/loading/LoadingPage";
    import LoadingModal from "@/components/loading/LoadingModal";
    import Menu from "@/menu/Menu";
    import ConfigurationBusiness from "@/business/ConfigurationBusiness";
    import AuthBusiness from "@/business/AuthBusiness";

    export default {
        name: "Layout",
        data() {
            return {
                layoutMode: store.getStaticMenu() || 'static',
                layoutColorMode: store.getLayoutColor() || 'dark',
                staticMenuInactive: false,
                overlayMenuActive: false,
                mobileMenuActive: false,
                menu : Menu.getMenu(store.getLoggedUser()),
                loadingPage: false,
                loadingModal: false,
                loggedUser: store.getLoggedUser()
            }
        },
        watch: {
            $route() {
                this.menuActive = false;
                this.$toast.removeAllGroups();
            }
        },
        methods: {
            onWrapperClick() {
                if (!this.menuClick) {
                    this.overlayMenuActive = false;
                    this.mobileMenuActive = false;
                }

                this.menuClick = false;
            },
            onMenuToggle() {
                this.menuClick = true;

                if (this.isDesktop()) {
                    if (this.layoutMode === 'overlay') {
                        this.overlayMenuActive = !this.overlayMenuActive;
                    }
                    else if (this.layoutMode === 'static') {
                        this.staticMenuInactive = !this.staticMenuInactive;
                    }
                }
                else {
                    this.mobileMenuActive = !this.mobileMenuActive;
                }

                event.preventDefault();
            },
            onSidebarClick() {
                this.menuClick = true;
            },
            onMenuItemClick(event) {
                if (event.item && !event.item.items) {
                    this.overlayMenuActive = false;
                    this.mobileMenuActive = false;
                }
            },
            addClass(element, className) {
                if (element.classList)
                    element.classList.add(className);
                else
                    element.className += ' ' + className;
            },
            removeClass(element, className) {
                if (element.classList)
                    element.classList.remove(className);
                else
                    element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            },
            isDesktop() {
                return window.innerWidth > 1024;
            },
            isSidebarVisible() {
                if (this.isDesktop()) {
                    if (this.layoutMode === 'static')
                        return !this.staticMenuInactive;
                    else if (this.layoutMode === 'overlay')
                        return this.overlayMenuActive;
                    else
                        return true;
                }
                else {
                    return true;
                }
            },
            updateLayoutColor(){
                this.layoutColorMode = store.getLayoutColor();
            },
            updateMenu(){
                this.layoutMode = store.getStaticMenu();
            },
            logout(){
                store.setLoggedUser(null);
                if(!this.$route.path.startsWith('/#/login')){
                    window.location.replace('/#/login');
                }
            },
        },
        computed: {
            containerClass() {
                return ['layout-wrapper', {
                    'layout-overlay': this.layoutMode === 'overlay',
                    'layout-static': this.layoutMode === 'static',
                    'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                    'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                    'layout-mobile-sidebar-active': this.mobileMenuActive
                }, this.theme];
            },
            sidebarClass() {
                return ['layout-sidebar', {
                    'layout-sidebar-dark': this.layoutColorMode === 'dark',
                    'layout-sidebar-light': this.layoutColorMode === 'light'
                }];
            },
            tolbarClass() {
                return [{
                    'layout-topbar-dark': this.layoutColorMode === 'dark',
                    'layout-topbar-light': this.layoutColorMode === 'light'
                }];
            },

            theme(){
                return this.layoutColorMode || 'dark';
            }
        },
        beforeUpdate() {
            if (this.mobileMenuActive)
                this.addClass(document.body, 'body-overflow-hidden');
            else
                this.removeClass(document.body, 'body-overflow-hidden');
        },

        async mounted() {
            EventBus.loadingPage(true);
            this.pageConfiguration = await ConfigurationBusiness.getLoginPageConfiguration();
            const user = await AuthBusiness.getLoggedUser();
            store.setLoggedUser(user);
            EventBus.loadingPage(false);
        },

        async beforeMount() {
            EventBus.$on('LAYOUT_COLOR', this.updateLayoutColor);
            EventBus.$on('STATIC_MENU', this.updateMenu);
            EventBus.$on('LOGOUT', this.logout);
            EventBus.$on('LOADING_PAGE', (loading) => this.loadingPage = loading);
            EventBus.$on('LOADING_MODAL', (loading) => this.loadingModal = loading);
        },
        beforeDestroy(){
            EventBus.$off('LAYOUT_COLOR', this.updateLayoutColor);
            EventBus.$off('STATIC_MENU', this.updateMenu);
            EventBus.$off('LOGOUT');
            EventBus.$off('LOADING_PAGE');
            EventBus.$off('LOADING_MODAL');
        },

        components: {
            LoadingModal,
            LoadingPage,
            'AppTopBar': AppTopBar,
            'AppProfile': AppProfile,
            'AppMenu': AppMenu,
        }
    }
</script>

<style lang="scss">
    @import './App.scss';
    .logo {
        max-height: 20px;
        max-width: 20px;
    }
</style>
